import { useState, useCallback, Dispatch, SetStateAction } from 'react';
import {
  IApiCallStatus,
  ICancelRequestOutput,
  IError,
  ResponseCSOSHeaders,
  cancelRequests,
  useUserContext,
} from '..';
import { find as lfind, isEmpty as lisEmpty } from 'lodash/fp';
import { fold } from 'fp-ts/Either';
import { flow } from 'fp-ts/function';

export const useCancelRequests = ({ requestIds }: { requestIds: number[] }) => {
  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();

  const { user } = useUserContext();

  const call = flow(
    () => setApiCallStatus(null),
    () => handleRequest(user.icam!.headers)(setApiCallStatus)(requestIds)
  );

  const reset = useCallback(() => setApiCallStatus(void 0), []);

  return {
    cancelRequestsStatus: apiCallStatus,
    cancelRequests: call,
    resetCancelRequests: reset,
  };
};

const handleRequest =
  (hR: ResponseCSOSHeaders) =>
  (setApiCallStatus: Dispatch<SetStateAction<IApiCallStatus>>) =>
  (requestIds: number[]) => {
    cancelRequests(hR)(requestIds).then(
      fold<IError, ICancelRequestOutput[], void>(
        () => setApiCallStatus(false),
        flow(lfind<ICancelRequestOutput>({ status: 'fail' }), lisEmpty, a =>
          a ? setApiCallStatus(true) : setApiCallStatus(false)
        )
      )
    );
  };
